module.exports = __webpack_public_path__ + "static/img/helpful-select.f4a3804f.png";